








































import Vue from 'vue';
import Component from 'vue-class-component';
import TicketsDashboardHeader from '@/modules/tickets/dashboard/components/TicketsDashboardHeader.vue';
import TicketsHeaderCards from '@/modules/tickets/dashboard/components/TicketsHeaderCards.vue';
import TicketsByStatus from '@/modules/tickets/dashboard/components/TicketsByStatus.vue';
import TicketsByType from '@/modules/tickets/dashboard/components/TicketsByType.vue';
import TicketsReviewDot from '@/modules/tickets/dashboard/components/TicketsReviewDot.vue';
import TicketsTable from '@/modules/tickets/dashboard/components/TicketsTable.vue';
import TicketsLastNMonthsActivity from '@/modules/tickets/dashboard/components/TicketsLastNMonthsActivity.vue';
import TicketsMonthSummary from '@/modules/tickets/dashboard/components/TicketsMonthSummary.vue';
import { layout, ticketsDashboard, user } from '@/modules/shared/shared/store/namespaces';
import {
    TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS,
    TICKETS_DASHBOARD_GET_TICKETS,
} from '@/modules/tickets/dashboard/store/tickets-dashboard.actions';

@Component({
    components: {
        TicketsLastNMonthsActivity,
        TicketsMonthSummary,
        TicketsReviewDot,
        TicketsByStatus,
        TicketsByType,
        TicketsHeaderCards,
        TicketsDashboardHeader,
        TicketsTable,
    },
})
export default class TicketsDashboard extends Vue {
    snackbar: boolean = false;
    snackbarError: boolean = false;
    newTicketId: number | string | any = -1;
    loadingError: boolean = false;
    timeout: number = 7000;

    @ticketsDashboard.Action(TICKETS_DASHBOARD_GET_TICKETS)
    TICKETS_DASHBOARD_GET_TICKETS;

    @ticketsDashboard.Action(TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS)
    TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS;

    @layout.Mutation('changeTitle') changeTitle;

    successCreationOfTicket() {
        if (this.$route.params.ticket === 'success') {
            this.snackbar = true;
            this.newTicketId = this.$route.params.id;
        } else if (this.$route.params.ticket === 'error') {
            this.snackbarError = true;
        }
    }

    mounted() {
        try {
            this.changeTitle({ title: 'Histórico', route: ['TICKETS'] }); // Antes: Dashboard
            this.successCreationOfTicket();
            this.TICKETS_DASHBOARD_GET_TICKETS();
            this.TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS({ start: 1, limit: 10 });
        } catch (err) {
            this.loadingError = true;
        }
    }
}
